
/**
 * 方法实现里，需要把能读到的参数都读出来，上报就要上报全面，有利于分析数据
 * @param params 上报的参数
 */
const logToServer = (params: any) => {
  let data = Object.assign({date:Date.now()}, params);
  // 添加全局参数
  data = Object.assign(data, readGlobalParams());
  // 添加浏览器参数
  data = Object.assign(data, readBrowserParams());
  if (process.env.NODE_ENV !== 'production') {
    console.log('开发环境，不上报bug，打印在控制台：', JSON.parse(JSON.stringify(data)));
  }
  // 表单
  const fd = new FormData(); 
  if (data['companyId']) {
    fd.append('companyId', data['companyId']);
    delete data.companyId;
  }
  if (data['site']) {
    fd.append('site', data['site']);
    delete data.site;
  }
  if (data['ru']) {
    fd.append('requestUrl', data['ru']);
    delete data.ru;
  }
  if (data['em']) {
    fd.append('reason', data['em']);
    delete data.em;
  }
  if (data['type']) {
    fd.append('type', data['type']);
  }
  if (data['time']) {
    fd.append('time', `${Math.ceil(Number(data['time']))}`);
    delete data.time;
  }
  if (data['cost']) {
    fd.append('cost', data['cost']);
    delete data.cost;
  }
  fd.append('param', JSON.stringify(data));
  
  if (process.env.NODE_ENV === 'production') {
    // 只有生产环境上报，开发环境不上报
    if (navigator?.sendBeacon) {
      navigator.sendBeacon('https://59b517704ce43f0f.cartx.cloud/monitor/request', fd);
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "https://59b517704ce43f0f.cartx.cloud/monitor/request");
      xhr.send(fd);
    }
  }
}

/**
 * 读取全局参数
 * @returns 全局参数
 */
const readGlobalParams = () => {
  const companyInfo = localStorage.getItem('companyInfo');
  return {
    companyId: companyInfo ? (JSON.parse(companyInfo)?.id ?? '') : '', // 公司id，有就传
    companyName: localStorage.getItem('companyName') ?? '', // 公司名称
    displayInfo: localStorage.getItem('displayInfo') ?? '', // 显示信息
  }
}

/**
 * 读取浏览器参数
 * @returns 浏览器参数
 */
const readBrowserParams = () => {
  return {
    site:window.location.href,
    ua:window.navigator?.userAgent,
  }
}

/**
 * 上报js报错
 * @param error js错误信息
 */
const LogJsError = (error: any) => {
  // 格式化报错
  let data:any = {
    type: 'JSERROR',
    error: null,
  }
  if (typeof error != 'object') {
    data.error = `${error}`;
  } else {
    data = Object.assign({type:'JSERROR'}, error);
  }
  // 进行上报
  logToServer(data);
}

/**
 * 上报500的错误
 * @param error 错误信息，需要给出url信息
 */
const Log500Error = (error: any) => {
  // 格式化报错
  let data:any = {
    type: '500ERROR',
    error: null,
  }
  if (typeof error != 'object') {
    data.error = `${error}`;
  } else {
    data = Object.assign({type:'500ERROR'}, error);
  }
  // 进行上报
  logToServer(data);
}

const LogTimeoutError = (error: any) => {
  // 格式化报错
  let data:any = {
    type: 'TIMEOUTERROR',
    error: null,
  }
  if (typeof error != 'object') {
    data.error = `${error}`;
  } else {
    data = Object.assign({type:'TIMEOUTERROR'}, error);
  }
  // 进行上报
  logToServer(data);
}

const logPageLoading = () => {
  const {
    redirectEnd,
    redirectStart,
    fetchStart,
    connectStart,
    connectEnd,
    requestStart,
    responseStart,
    responseEnd,
    domLoading,
    domInteractive,
    domComplete,
    domContentLoadedEventStart,
    domContentLoadedEventEnd,
    loadEventStart,
    loadEventEnd,
    navigationStart,
    domainLookupEnd,
    domainLookupStart,
  } = window.performance?.toJSON()?.timing || window.performance?.timing;
  // console.log(JSON.stringify(performance.toJSON().timing));
  const old = sessionStorage.getItem('cartx_page_load');
  if (old) {
    if (navigationStart != old) {
      sessionStorage.setItem('cartx_page_load', navigationStart);
    } else {
      return;
    }
  } else {
    sessionStorage.setItem('cartx_page_load', navigationStart);
  }
  // 重定向时间
  const redirectDuration = redirectEnd - redirectStart;
  // DNS查询耗时
  const dnsDuration = domainLookupEnd - domainLookupStart;
  // TCP链接耗时
  const tcpDuration = connectEnd - connectStart;
  // request耗时
  const requestDuration = responseEnd - requestStart;
  // 解析dom树耗时
  const domParseDuration = domComplete - domInteractive;
  // 白屏时间
  const whiteScreenDuration = domLoading - fetchStart;
  // onload时间（页面加载的大概时间，因为重定向时间和worker时间有时候为0统计不到）
  const onloadDuration = loadEventEnd == 0 ? (loadEventStart - fetchStart + 1) : (loadEventEnd - fetchStart);
  if (process.env.NODE_ENV !== 'production') {
    console.log('重定向时间', redirectDuration);
    console.log('DNS查询耗时', dnsDuration);
    console.log('TCP链接耗时', tcpDuration);
    console.log('request耗时', requestDuration);
    console.log('解析dom树耗时', domParseDuration);
    console.log('白屏时间', whiteScreenDuration);
    console.log('onload时间', onloadDuration);
  }
  logToServer({
    type: 'pageload',
    pp: {
      redirect:redirectDuration,
      dns:dnsDuration,
      tcp:tcpDuration,
      req:requestDuration,
      domParse:domParseDuration,
      whiteScreen:whiteScreenDuration,
      onload:onloadDuration,
    },
    time:onloadDuration,
  })
}

/**
 * 上报请求加载时长
 */
const LogRequestInfo = (info: any) => {
  // 格式化报错
  let data:any = {
    type: 'requestDuration',
    em: 'requestDuration',
    error: null,
  }
  if (typeof info != 'object') {
    data.error = `${info}`;
  } else {
    data = Object.assign({type:'requestDuration', em: 'requestDuration',}, info);
  }
  // 进行上报
  logToServer(data);
}

/**
 * 上报长任务
 */
const LogLongTaskInfo = (info: any) => {
  // 格式化报错
  let data:any = {
    type: 'LongTask',
    error: 'LongTask',
    em: 'LongTask',
  }
  if (typeof info != 'object') {
    data.error = `${info}`;
  } else {
    data = Object.assign({type:'LongTask', em: 'LongTask',}, info);
  }
  // 进行上报
  logToServer(data);
}

export { Log500Error, LogJsError, LogTimeoutError, logPageLoading, LogRequestInfo, LogLongTaskInfo };
